var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#00263E"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.03 17.375h2.814V20H11.03zM7.691 9.773q0-1.155.346-2.1a4.5 4.5 0 0 1 1.008-1.617 4.5 4.5 0 0 1 1.597-1.04q.934-.367 2.089-.367.965 0 1.796.284a4.3 4.3 0 0 1 1.449.819q.62.535.976 1.333.357.798.357 1.806 0 .735-.158 1.27a3.3 3.3 0 0 1-.42.925q-.262.389-.598.692-.336.306-.672.599-.399.336-.735.651a3.8 3.8 0 0 0-.588.704 3.1 3.1 0 0 0-.389.913q-.136.525-.136 1.281h-2.268q0-.924.095-1.565.094-.64.304-1.123t.515-.85q.304-.369.724-.725.336-.294.64-.546.305-.252.547-.557.24-.304.377-.682.138-.378.137-.903 0-.63-.22-1.081a2.25 2.25 0 0 0-.536-.725 2.1 2.1 0 0 0-.672-.399 2 2 0 0 0-.63-.126q-1.302 0-1.921.85-.62.851-.62 2.279z"
  }))));
};
export default SvgHelp;